<template>
  <div class="header">
    <h2>
      <i>{{ header }}</i>
    </h2>
  </div>
</template>

<script>
export default {
  props: ['header']
}
</script>

<style scoped>
  .header {
    margin-bottom: 60px;
  }

  .header h2 {
    color: #FFA500;
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/components/STUDENTS/Life_Header.vue